module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-footer-wrapper"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49447eee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/layout/rtFooter.vue
// module id = 1504
// module chunks = 124